import gql from 'graphql-tag';

import client from '../graphqlAPI';

// One page of the sent-email archive, newest first (ps-email-archive/CONTRACT.md §5).
// `nextCursor` is null on the last page; there is no total — DynamoDB has none.
const GET_SENT_EMAILS = gql`
  query getSentEmails($filters: SentEmailsFilters, $cursor: String, $limit: Int) {
    getSentEmails(filters: $filters, cursor: $cursor, limit: $limit) {
      isAuth
      error
      nextCursor
      items {
        messageId
        sentAt
        recipient
        from
        subject
        kind
        source
        dataClass
        status
        archiveState
      }
    }
  }
`;

// Resolves to the SentEmailsResult, or null when the request itself failed
// (network, GraphQL error) — the caller shows a failure banner for null.
const getSentEmails = async (variables) => {
  try {
    const result = await client.query({
      query: GET_SENT_EMAILS, variables, errorPolicy: 'all', fetchResults: true, fetchPolicy: 'no-cache',
    }).catch((queryError) => {
      console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ getSentEmails Query Error: ${queryError}`);
      return null;
    });
    return result && result.data ? result.data.getSentEmails : null;
  } catch (error) {
    console.log('\x1b[31m%s\x1b[0m', `${new Date().toLocaleTimeString()} ~ getSentEmails Error: ${error}`);
    return null;
  }
};

export default getSentEmails;
